// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ksKVx_ilBaor4aVHa6x_{background:var(--background-neutral-default);border-radius:8px}.ksKVx_ilBaor4aVHa6x_ .dvEy3KqZ_IaG3qBGrUm_{grid-template-columns:1fr max-content;justify-content:space-between;display:grid}.ksKVx_ilBaor4aVHa6x_ .dvEy3KqZ_IaG3qBGrUm_ .Qic7JDuHUZIK1bRSN2Bl{padding:12px 12px 8px;display:grid}.ksKVx_ilBaor4aVHa6x_ .dvEy3KqZ_IaG3qBGrUm_ .D7_DiSEEtMwn6MY4_pRg{margin-top:8px;margin-right:8px;display:flex}.y7Z8rIwHaUQzTfHkrsUV{flex-direction:column;gap:12px;padding:4px 12px 12px;display:flex}.y7Z8rIwHaUQzTfHkrsUV .PSh3xc6eoIk_Qz2LWJR4{background:var(--background-primary-inverted-primary);border-radius:4px;grid-template-columns:24px 1fr;align-items:center;gap:4px;height:32px;padding:4px;display:grid}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `ksKVx_ilBaor4aVHa6x_`,
	"header": `dvEy3KqZ_IaG3qBGrUm_`,
	"left": `Qic7JDuHUZIK1bRSN2Bl`,
	"right": `D7_DiSEEtMwn6MY4_pRg`,
	"content": `y7Z8rIwHaUQzTfHkrsUV`,
	"card": `PSh3xc6eoIk_Qz2LWJR4`
};
export default ___CSS_LOADER_EXPORT___;
